import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

// import openSocket from 'socket.io-client';
import { io } from "socket.io-client";

import { useStore } from '../../hook-store/store';
// import * as bucketObjectUtils from '../../../utils/bucket/bucket-object-util'

import { BACKEND_URL } from '../../App';

// import classes from './PostSelect.module.css';
// export let socket;

function FilesUploadActionSocket(props) {
  // const { } = props;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  // const { allBucketObjects } = store.bucketObjectStore;
  // const { allObjectsMetaList } = store.objectMetadataStore;
  // const { shareObjects } = store.shareObjectStore;
  // const { bucketName, currentPrefix } = store.bucketObjectStore;
  // const { isAuth } = store.uiStore;

  // const [shareObjectUpdateData, setShareObjectUpdateData] = useState();

  useEffect(() => {
      // const socket = openSocket(BACKEND_URL);
      const socket = io(BACKEND_URL, {
        // autoConnect: false
      });

      const userId = localStorage.getItem('userId');

      socket.on("connect", () => {
        console.log('connect socket.id', socket.id);
        // dispatch('SET_SOCKETID', socket.id);

        socket.emit('user-id', {
          socketId: socket.id,
          userId: userId,
          token: localStorage.getItem('token'),
        });
      });

      // socket.on("casauthsso-user-name-data-update", (data) => {
      //   console.log('casauthsso-user-name-data-update data', data);
      //   // dispatch('SET_SOCKETID', socket.id);
      //   if (data?.userNameData?.userId === localStorage.getItem('userId')) {
      //     dispatch('SET_USERNAMEDATA', data.userNameData);
      //   }
      // });

      // //// for files uploaded 
      // socket.on('files-upload', data => {
      //   console.log('files-upload data', data);
        
      //   // const uData = data.data;
        
      //   // //// update objects when upload origin is different
      //   // if (isAuth && uData && uData.origin && 
      //   //     uData.origin !== window.location.origin 
      //   // ) {
      //   //     dispatch('SET_OBJECTACTION', {
      //   //       actionType: 'file-upload',
      //   //       delete: false,
      //   //       add: true,
      //   //       result: '',
      //   //     });

      //   //     if (uData.dataForMetadata) {
      //   //       dispatch('SET_DATAFORMETADATA', uData.dataForMetadata);
      //   //     }
          
      //   // }
      // });

      //// for chunks file upload
      socket.on('large-file-upload-progress', data => {
        console.log('large-file-upload-progress', data);

        const fileIdx = data.fileIdx;
        const totalFileNum = data.totalFileNum;
        const progress = parseInt((data.processed / data.totalChunks)*100)
        const processAction = data.processAction;
        const origin = data.origin;

        if (window.location.origin === origin && 
            processAction === 'storeFiles'
        ) {
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber40', 'uploading...')} ${fileIdx+1}/${totalFileNum} ${progress}%`,
            message: '',
          });
        }
      });

      socket.on('large-file-upload-finish', data => {
        console.log('large-file-upload-finish', data);

        const fileIdx = data.fileIdx;
        const totalFileNum = data.totalFileNum;
        const processAction = data.processAction;
        const origin = data.origin;
        
        if (window.location.origin === origin && 
            processAction === 'storeFiles'
        ) {
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber44', 'file uploading')} ${fileIdx+1}/${totalFileNum} 100%, ${t('audioTranscriber43', 'file storing...')}`,
            message: '',
          })
        }
      });
      
      return () => {
        socket.off('connect');
        socket.off('disconnect');
        // socket.off('casauthsso-user-name-data-update');
        // socket.off('files-upload');
        socket.off('large-file-upload-progress');
        socket.off('large-file-upload-finish');
      }

  },[]);


  return (
    <Fragment></Fragment>
  );
}

export default FilesUploadActionSocket;